export default __webpack_public_path__ + "static/media/Snow Fairy-img.7e8d89ab.png";